import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import {
  AUTH_MAIN_ROUTE,
  AUTH_ROUTES,
} from '../../constants/auth.routing.constants';
import { OnboardingService } from '../../services/onboarding/onboarding.service';

// A failed check returns true so a lookup error never blocks creating a workspace.
export const onboardingResumeGuard: CanActivateFn = () => {
  const router = inject(Router);

  return inject(OnboardingService)
    .inProgressWorkspace()
    .pipe(
      map(res =>
        res.data?.id
          ? router.createUrlTree([
              '/',
              AUTH_MAIN_ROUTE,
              AUTH_ROUTES.WORKSPACE_SETUP,
              res.data.id,
            ])
          : true
      ),
      catchError(() => of(true))
    );
};
